import { Text } from '@lmc/design-system'
import type { ReactNode } from 'react'
import styled from 'styled-components'

type StepFieldLabelProps = {
  id?: string
  label: ReactNode
  hint?: ReactNode
  isRequired?: boolean
}

/**
 * A v2 step field's label: the name, a red asterisk when required, and an
 * optional hint under it. The steps' forms turn off antd's own required mark
 * so this is the only one.
 */
const StepFieldLabel = ({
  id,
  label,
  hint,
  isRequired
}: StepFieldLabelProps) => (
  <span>
    {/* `id` names a group by the label alone, without the hint. */}
    <Text as="span" weight="semibold" id={id}>
      {label}
    </Text>
    {isRequired && (
      <Text as="span" variant="body-sm" tone="critical">
        {' *'}
      </Text>
    )}
    {hint && (
      <Hint tone="secondary" forwardedAs="span">
        {hint}
      </Hint>
    )}
  </span>
)

// A span, because it sits inside the field's <label>; block so it takes its
// own line under the name, as designed.
const Hint = styled(Text)`
  display: block;
`

export default StepFieldLabel
